module.exports = __webpack_public_path__ + "img/roodie-white_cyan.9806c906.svg";